export interface StringSegment {
  start: number;
  end: number;
  process: (segment: string) => string;
}

const processStringSegment = (str: string, segment: StringSegment) => {
  const oldValue = str.substring(segment.start, segment.end);
  const newValue = segment.process(oldValue);

  if (oldValue !== newValue) {
    const head = str.substring(0, segment.start);
    const tail = str.substring(segment.end);
    return `${head}${newValue}${tail}`;
  }

  return str;
};

export const processStringSegments = (str: string, segments: StringSegment[]) => {
  let i = segments.length - 1;
  let segment: StringSegment;

  while ((segment = segments[i])) {
    str = processStringSegment(str, segment);
    i -= 1;
  }

  return str;
};
